import styled, { keyframes } from 'styled-components';

const fadeText = keyframes` 
   from {
     opacity: 0;
     transform: translate3d(0, 100%, 0);
   }
   to {
     opacity: 1;
     transform: none;
   }
 `;

export const Header = styled.div`
  text-align: center;
  .logo {
    height: ${props => (props.large ? '65px' : props.medium ? '60px' : '55px')}!important; 
    filter: invert(0%) sepia(0%) saturate(16%) hue-rotate(293deg) brightness(0%) contrast(106%);
    animation: ${fadeText} 0.6s ease-in-out 0s forwards;
  }
  .title {
    font-family: 'Oswald';
    margin: 15px auto;
    text-transform: uppercase;
    font-size:${props => (props.large ? '2.4rem' : props.medium ? '2.2rem' : '2rem')}!important;  
    animation: ${fadeText} 1s ease-in-out 0s forwards;
  } 
`;
